function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCheckInCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.25A8.751 8.751 0 0118.75 10 8.75 8.75 0 0110 18.75a8.75 8.75 0 010-17.5zm0 1.25a7.501 7.501 0 11-.002 15.002A7.501 7.501 0 0110 2.5z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.081 13.75L5 10.668l.974-.973 2.107 2.108 5.553-5.553.973.974-6.526 6.526z",
    fill: props.color
  }));
}

export default SvgIconCheckInCircle;